"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * development API of Digital Villages Platform
 * See digitale-doerfer-api.json (info.description) for more details
 *
 * The version of the OpenAPI document: See digitale-doerfer-api.json
 * Contact: support@digitale-doerfer.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function ClientGroupCreateByAdminRequestFromJSON(json) {
    return ClientGroupCreateByAdminRequestFromJSONTyped(json, false);
}
exports.ClientGroupCreateByAdminRequestFromJSON = ClientGroupCreateByAdminRequestFromJSON;
function ClientGroupCreateByAdminRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'geoAreaIds': !runtime_1.exists(json, 'geoAreaIds') ? undefined : json['geoAreaIds'],
        'groupAccessibility': json['groupAccessibility'],
        'groupContentVisibility': json['groupContentVisibility'],
        'groupMembershipAdminIds': !runtime_1.exists(json, 'groupMembershipAdminIds') ? undefined : json['groupMembershipAdminIds'],
        'groupVisibility': json['groupVisibility'],
        'name': json['name'],
        'shortName': json['shortName'],
        'tenantId': json['tenantId'],
    };
}
exports.ClientGroupCreateByAdminRequestFromJSONTyped = ClientGroupCreateByAdminRequestFromJSONTyped;
function ClientGroupCreateByAdminRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'geoAreaIds': value.geoAreaIds,
        'groupAccessibility': value.groupAccessibility,
        'groupContentVisibility': value.groupContentVisibility,
        'groupMembershipAdminIds': value.groupMembershipAdminIds,
        'groupVisibility': value.groupVisibility,
        'name': value.name,
        'shortName': value.shortName,
        'tenantId': value.tenantId,
    };
}
exports.ClientGroupCreateByAdminRequestToJSON = ClientGroupCreateByAdminRequestToJSON;
/**
* @export
* @enum {string}
*/
var ClientGroupCreateByAdminRequestGroupAccessibilityEnum;
(function (ClientGroupCreateByAdminRequestGroupAccessibilityEnum) {
    ClientGroupCreateByAdminRequestGroupAccessibilityEnum["PUBLIC"] = "PUBLIC";
    ClientGroupCreateByAdminRequestGroupAccessibilityEnum["APPROVALREQUIRED"] = "APPROVAL_REQUIRED";
})(ClientGroupCreateByAdminRequestGroupAccessibilityEnum = exports.ClientGroupCreateByAdminRequestGroupAccessibilityEnum || (exports.ClientGroupCreateByAdminRequestGroupAccessibilityEnum = {}));
/**
* @export
* @enum {string}
*/
var ClientGroupCreateByAdminRequestGroupContentVisibilityEnum;
(function (ClientGroupCreateByAdminRequestGroupContentVisibilityEnum) {
    ClientGroupCreateByAdminRequestGroupContentVisibilityEnum["ANYONE"] = "ANYONE";
    ClientGroupCreateByAdminRequestGroupContentVisibilityEnum["SAMEHOMEAREA"] = "SAME_HOME_AREA";
    ClientGroupCreateByAdminRequestGroupContentVisibilityEnum["MEMBERS"] = "MEMBERS";
})(ClientGroupCreateByAdminRequestGroupContentVisibilityEnum = exports.ClientGroupCreateByAdminRequestGroupContentVisibilityEnum || (exports.ClientGroupCreateByAdminRequestGroupContentVisibilityEnum = {}));
/**
* @export
* @enum {string}
*/
var ClientGroupCreateByAdminRequestGroupVisibilityEnum;
(function (ClientGroupCreateByAdminRequestGroupVisibilityEnum) {
    ClientGroupCreateByAdminRequestGroupVisibilityEnum["ANYONE"] = "ANYONE";
    ClientGroupCreateByAdminRequestGroupVisibilityEnum["SAMEHOMEAREA"] = "SAME_HOME_AREA";
    ClientGroupCreateByAdminRequestGroupVisibilityEnum["MEMBERS"] = "MEMBERS";
})(ClientGroupCreateByAdminRequestGroupVisibilityEnum = exports.ClientGroupCreateByAdminRequestGroupVisibilityEnum || (exports.ClientGroupCreateByAdminRequestGroupVisibilityEnum = {}));
